import { render, staticRenderFns } from "./ProjectBookingReviewTimeline.vue?vue&type=template&id=9b31bfc8&scoped=true&"
import script from "./ProjectBookingReviewTimeline.vue?vue&type=script&lang=js&"
export * from "./ProjectBookingReviewTimeline.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBookingReviewTimeline.vue?vue&type=style&index=0&id=9b31bfc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b31bfc8",
  null
  
)

export default component.exports